import React from 'react';
import { Grid } from '@material-ui/core';

import Description from 'components/typography/Description';

const IngredientsDescription = () => {
  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <Description>
          Now, list your recipe <b>ingredients</b>. Don't forget to specify
          their
          <b> quantity</b>.
        </Description>
      </Grid>
      <Grid item container direction="column">
        <Description>
          <i>Example:</i>
        </Description>

        <Grid item container direction="column">
          <ul>
            <li>
              <Grid item>
                <Description>5 white eggs</Description>
              </Grid>
            </li>
            <li>
              <Grid item>
                <Description>
                  <sup>1</sup>&frasl;<sub>2</sub> teaspoon of black peper
                </Description>
              </Grid>
            </li>
            <li>
              <Grid item>
                <Description>500 ml of water ...</Description>
              </Grid>
            </li>
          </ul>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IngredientsDescription;
